// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListB_TheComp__U6dUq"};